module.exports = __webpack_public_path__ + "static/portfolio-mowaamah-1e49999410e94bc017a4c63b966eda57.png";